import React from "react";
import { Alert, Empty } from "antd";
import useClinicalRoleForms from "../../../hooks/useClinicalRoleForms";
import ClinicalFormPanel from "./ClinicalFormPanel";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import { fromApiForm } from "../../../mappers/clinicalForms.mappers";

const ClinicalPractitionerFormById = ({ formId, admissionId, admissionType }) => {
  const { forms, loading, error } = useClinicalRoleForms(
    admissionId,
    admissionType
  );

  if (loading) return <LoadingIndicator message="Loading form" />;
  if (error) return <Alert type="error" message={error} showIcon />;

  const raw = (forms || []).find((f) => String(f?.id) === String(formId));
  if (!raw)
    return (
      <Empty
        style={{ marginTop: 60 }}
        description="Form not available for this admission"
      />
    );

  return (
    <ClinicalFormPanel
      form={fromApiForm(raw)}
      admissionId={admissionId}
      admissionType={admissionType}
      confirmExit
    />
  );
};

export default ClinicalPractitionerFormById;
